import React from "react";
import "./HeroSection.css";
import { FaArrowRight, FaUserFriends } from "react-icons/fa";
import Slider from "./Slider";

const HeroSection = () => {
  return (
    <>
    <Slider/>
    <section className="heroSection">
      {/* Decorative Circles Background */}
      <div className="heroSection-bg-circles"></div>

      <div className="heroSection-left">
        <div className="heroSection-subtitle-container">
          <div className="line"></div>
          <span className="subtitle">TRAVEL SIMPLIFIED</span>
          <span className="star">✦</span>
        </div>
        
        <h1>
          <span className="title-part-1">Discover the World</span><br />
          <span className="title-part-2">Your Way</span>
        </h1>
        
        <p>
          We connect buyers and suppliers across the globe with cutting-edge
          travel solutions. From hotels and airlines to car rentals and cruises,
          our platform enables seamless journeys for businesses and travelers.
        </p>
        
        <div className="heroSection-buttons">
          <a className="heroSection-link" href="https://flyabasin.com/" target="_blank" rel="noopener noreferrer">
            <button className="heroSection-btn heroSection-primary">
              Get Started <FaArrowRight className="heroSection-icon" />
            </button>
          </a>
        </div>
      </div>

      <div className="heroSection-right">
        {/* Decorative Dots Background */}
        <div className="heroSection-bg-dots"></div>

        <div className="heroSection-image-wrapper heroSection-hover-tilt">
          <img
            src="https://images.pexels.com/photos/33992405/pexels-photo-33992405.jpeg"
            alt="Emirates Plane"
          />
        </div>
        
        <div className="heroSection-floating-badge">
          <div className="badge-icon">
            <FaUserFriends />
          </div>
          <div className="badge-text">
            <span className="badge-title">Trusted by</span>
            <span className="badge-value">Thousands of Users</span>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default HeroSection;
